export const STEP_QUERY_PARAM = 'etape';
export const FIRST_STEP = 1;
export const STEPS = ['', 'device', 'contact', 'confirmation'];
